// 차량 용도(자동차등록증 '용도' 항목) 프리셋 — 2026-08-21 (#312 후속)
//
// 등록증 규범은 자가용/영업용/관용 3종. 그 외 예외 표기는 '직접입력'으로 받는다.
// 이전에는 웹이 자유 입력이라 검증이 없었고, 앱은 법인 차주면 '법인'(소유 형태)을
// 용도 칸에 넣어 등록증에 없는 값이 섞였다. 선택형으로 통일해 유입을 막는다.
//
// ⚠️ '법인'은 용도가 아니라 소유 형태다. 법인 식별은 매입유형(purchaseType='business')이
//    담당한다 — 운영 데이터상 법인 소유 차량의 88%가 등록증에 '자가용'으로 찍혀 있었다.

export var CAR_USAGE_PRESETS = ['자가용', '영업용', '관용']; // 자가용/영업용/관용
export var CAR_USAGE_CUSTOM = '직접입력'; // 직접입력

// 값이 프리셋에 없으면 '직접입력' 모드로 봐야 한다 (레거시 '법인' 등 포함).
export function isPresetUsage(v) {
  return CAR_USAGE_PRESETS.indexOf(String(v == null ? '' : v).trim()) >= 0;
}
